module.exports = __webpack_public_path__ + "static/img/p1.4422bfd.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/resources/images/icon/p1.png
// module id = umZX
// module chunks = 1